<template>
	<div v-parallax-fit="parallax" class="hand">
		<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/20_GavelHand@2x.png" alt="">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				parallax: [
					{
						start: 27000,
						end: 28300,
						fromStyle: { transform: 'translateY(-500%) rotate(60deg)' },
           				toStyle: { transform: 'translateY(0%) rotate(-22deg)' },
						easing: 'linear'
					},
					{
						start: 30000,
						end: 33000,
						fromStyle: { transform: 'translateY(0%) rotate(-22deg)' },
           				toStyle: { transform: 'translateY(500%) rotate(-22deg)' },
						easing: 'linear'
					}
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	.hand {
		position: absolute;
		left: 100%;
		bottom: 0;
		transition: all 0.6s linear;
		min-width: 1300px;
		margin-left: -238px;
		margin-bottom: -150px;
		transform-origin: left bottom;
	}

	@media screen and (max-width: 991px) {
		.hand {
			min-width: 900px;
			margin-left: -180px;
			margin-bottom: -110px;
		}
	}

	@media screen and (max-width: 650px) {
		.hand {
			min-width: 600px;
		    margin-left: -124px;
		    margin-bottom: -81px;
		}
	}
</style>
